
import { Component, Vue, Prop } from 'vue-property-decorator';
import { lAreaData } from '@/const/LAreaData';

@Component({
  name: 'selectArea'
})
export default class extends Vue {
  // 接受父组件的值
  @Prop({
    type: Boolean,
    default: false
  })areaVisible!:Boolean;

  private close() {
    this.$emit('close', false);
  }
  // 省市区元数据
  private lAreaData = lAreaData;
  private selected = ''
  // 保存返回数据
  private selectAreaBean:any={}

  private defaultProps:any = {
    children: 'child',
    label: 'name',
    value: 'id'
  }

  created() {
    this.selectAreaBean = {};
    this.lAreaData = lAreaData;
    this.lAreaData.map((item:any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item && item.child && item.child.map((temp:any) => {
          if (temp && temp.child && temp.child.length === 0) {
            (temp.child as any) = undefined;
          }
        });
      }
    });
  }

  private changeHandle(value: any) {
    this.selectAreaBean = {
      province: this.selected[0],
      province_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[0],
      city: this.selected[1],
      city_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[1],
      district: this.selected[2],
      district_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[2],
      adcode: (this.$refs.myCascader as any).getCheckedNodes()[0].data.adcode
    };
  }
  private save() {
    this.$emit('areaSave', this.selectAreaBean);
    this.$emit('close', false);
  }
}
